const ACCOUNT_SYNC_API = "https://us-central1-etikaf-admin.cloudfunctions.net/syncEtikafAccount";

export const syncEtikafAccount = async (user) => {
  if (!user) return null;

  const idToken = await user.getIdToken(true);
  const response = await fetch(ACCOUNT_SYNC_API, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({}),
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.error || "Peranan akaun tidak dapat diselaraskan.");
  }

  return data.roles || null;
};
